import { Paper, useTheme } from '@mui/material';
import type { Theme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';

import { UI_BUTTON_SECONDARY } from '../../../../constants/uiConstants';
import SimpleButton from '../../../atoms/button/simpleButton';
import { StyledAppBar } from '../common/styledAppBar';

const shouldShowLoginButton = (path: string) => {
	const pathsToCheck = ['/message', '/register', '/password/forgot', '/signin/activate', '/signin/reactivate'];
	return pathsToCheck.some(subPath => path.includes(subPath));
};

const hsbcLogoAsset = (theme: Theme) => {
	return (
		<>
			<span
				style={{
					width: '1px',
					height: '30px',
					background: 'black',
					marginLeft: theme.tsGoUnit.tsUnitOneAndHalf,
				}}
			/>
			<p
				style={{
					fontSize: theme.typography.tsFontSize.default,
					fontWeight: theme.typography.tsFontWeight.default,
					lineHeight: theme.tsGoUnit.tsUnitTriple,
					color: 'black',
					margin: '0 0 0 30px',
					position: 'relative',
				}}
			>
				{' '}
				Business Virtual Cards
			</p>
		</>
	);
};

const AuthForm = ({ children }) => {
	const location = useLocation();
	const theme = useTheme();
	const navigate = useNavigate();

	return (
		<Paper
			style={{
				gap: '25px',
				flexDirection: 'column',
				backgroundColor: 'initial',
				height: '100dvh',
				paddingBottom: theme.tsGoUnit.tsUnit,
				overflow: 'auto',
				display: 'flex',
			}}
		>
			<StyledAppBar position="sticky">
				{globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? hsbcLogoAsset(theme) : null}
				{shouldShowLoginButton(location.pathname) ? (
					<SimpleButton
						dataTestId="login-btn"
						label={'Login'}
						onClick={() => {
							void navigate('/signin/login');
						}}
						disabled={false}
						color={UI_BUTTON_SECONDARY}
					/>
				) : null}
			</StyledAppBar>
			{children}
		</Paper>
	);
};

export default AuthForm;
